import React from "react";
import { Select } from "../../form-inputs/inputs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedo, faTrash } from "@fortawesome/free-solid-svg-icons";

export const ShotControls = ({
    disableSourceSelect,
    canChangeSource,
    canSkip,
    canRemove,
    canRotate,
    processing,
    editedSources,
    editingSourceId,
    onChangeSource,
    onDeleteShot,
    onRotateImage,
    isVODelete,
}) => {
    return (
        <div className="shot-controls">
            <div className="input-group">
                {canChangeSource && (
                    <Select
                        disabled={disableSourceSelect}
                        name="editingSourceId"
                        defaultValue={editingSourceId}
                        className="-x-small"
                        options={editedSources}
                        updateOnChange={onChangeSource}
                        excludeSelect={true}
                    />
                )}
                {!canSkip && <div className="form-field" />}
                {canRemove ? (
                    <>
                        <div className={isVODelete ? "-read-only icon" : "icon"} onClick={onDeleteShot}>
                            <FontAwesomeIcon className={processing || isVODelete ? "disabled" : ""} icon={faTrash} />
                        </div>
                        {canRotate && (
                            <div className={isVODelete ? "-read-only icon" : "icon"} onClick={onRotateImage}>
                                <FontAwesomeIcon className={processing || isVODelete ? "disabled" : ""} icon={faRedo} />
                            </div>
                        )}
                    </>
                ) : (
                    <div className="shot-control--empty" />
                )}
            </div>
        </div>
    );
};
